import { Pipe, PipeTransform } from "@angular/core";


@Pipe({
    name: "includes",
})
export class IncludesPipe implements PipeTransform {

    transform(array?: string[], str?: string): boolean {
        if(!array || !str) return false
        return array.includes(str)
    }

}